import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const login = (username, password) => async (dispatch) => {
  try {
    const response = await axios.post(`${BASE_URL}/v1/api/adminLogin`, {
      username: username,
      password: password,
    });

    if (response.data.meta.status) {
      const token = response.data.data.token;

      // Store in localStorage
      localStorage.setItem("token", token);

      // Store in Redux
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: {
          ...response.data.data,
          token: token,
        },
      });

      return response.data;
    } else {
      dispatch({ type: "LOGIN_FAIL" });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: "LOGIN_FAIL" });
    throw error;
  }
};

export const getMyPermissions = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No token found");
    }

    const response = await axios.get(`${BASE_URL}/v1/api/getMyPermissions`, {
      headers: { authorization: token },
    });

    if (response.data.meta.status) {
      const permissions = response.data.data.map((p) => p.permission_name);
      localStorage.setItem("permissions", JSON.stringify(permissions));
      dispatch({ type: "SET_PERMISSIONS", payload: permissions });
      return response.data;
    }
  } catch (error) {
    console.error("Failed to fetch permissions:", error);
    throw error;
  }
};

export const logout = () => (dispatch) => {
  localStorage.clear();
  sessionStorage.clear();
  dispatch({ type: "LOGOUT" });
};
